import React from 'react';
import type { FC } from 'react';
import { Route, Routes } from 'react-router';

import { CreativeAssets } from './assets';
import { CreateCreative } from './create';
import { CreativesGenerator } from './generator';

export const Creatives: FC = () => {
    return (
        <Routes>
            <Route path="/assets/:creativeId" element={<CreativeAssets />} />
            <Route path="/create" element={<CreateCreative />} />
            <Route path="/generate/:creativeId" element={<CreativesGenerator />} />
        </Routes>
    );
};
